// extracted by mini-css-extract-plugin
module.exports = {"title":"Scheduled_title__Yms8o"};